<script setup lang="ts">
import { computed } from 'vue';

import { BoardBasisCode } from '@libs/trip-planner-interfaces';
import { AppSvgIcon } from '@libs/ui';

interface BoardBasisTagProps {
  boardBasisCode: BoardBasisCode;
  translationsCallback: (code: BoardBasisCode) => string;
}

const props = defineProps<BoardBasisTagProps>();

const boardBasisLabel = computed<string | undefined>(() => {
  if (props.boardBasisCode === BoardBasisCode.RoomOnly) {
    return undefined;
  }
  return props.translationsCallback(props.boardBasisCode);
});
</script>

<template>
  <div v-if="boardBasisLabel" class="board-basis-tag">
    <AppSvgIcon name="food" size="18" color="color-brand-jungle" />
    <div class="meal-info">
      <span>{{ boardBasisLabel }}</span>
    </div>
  </div>
</template>

<style scoped lang="scss">
.board-basis-tag {
  display: flex;
  align-self: flex-start;
  align-items: center;
  gap: var(--spacing-4);
  padding-top: var(--spacing-4);
  color: var(--color-brand-jungle);

  .meal-info {
    @include font-body-s-bold;
  }
}
</style>
